import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import API_BASE_URL from "../config";
export const showToast = (title, icon = "success") => {
  Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon,
    title,
  });
};

const EditBookingLocation = ({ bookingId, onClose }) => {
  const [locationType, setLocationType] = useState("In-Meeting Link");
  const [locationValue, setLocationValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (bookingId) {
      fetchCurrentLocation();
    }
  }, [bookingId]);

  const fetchCurrentLocation = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${API_BASE_URL}/event/bookings/${bookingId}`
      );
      if (res.data?.location) {
        setLocationValue(res.data.location);
      }
    } catch (error) {
      console.error("Error fetching booking location:", error);
      showToast("Failed to load current location.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (locationValue.trim() === "") {
      showToast("Please provide the location details.", "warning");
      return;
    }

    try {
      setSubmitting(true);
      await axios.post(`${API_BASE_URL}/event/update-booking`, {
        booking_id: bookingId,
        update_type: "location",
        value: locationValue,
      });
      showToast("Location updated successfully!");
      onClose();
    } catch (error) {
      console.error("Error updating location:", error);
      showToast("Failed to update location.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  if (!bookingId) {
    return null;
  }

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Location</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <Form.Group className="mb-3">
              <Form.Label>Select Location Type</Form.Label>
              <Form.Select
                value={locationType}
                onChange={(e) => setLocationType(e.target.value)}
              >
                <option>In-Meeting Link</option>
                <option>In Person</option>
                <option>Phone Number</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Enter {locationType} Details</Form.Label>
              <Form.Control
                type="text"
                placeholder={`Enter ${locationType}`}
                value={locationValue}
                onChange={(e) => setLocationValue(e.target.value)}
              />
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={handleSubmit}
          disabled={submitting || loading}
        >
          {submitting ? "Submitting..." : "Save Location"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditBookingLocation;
